import { useAppSelector } from '../../state';
import { selectSelectedMaskedAccount } from '../../state/slices/slice-link-api';
import { getAccountSelectionTextFromMaskedAccount } from '../../utils/account-selection';
function useSelectedAccountText() {
    var maskedAccount = useAppSelector(selectSelectedMaskedAccount);
    return getAccountSelectionTextFromMaskedAccount(maskedAccount);
}
export default useSelectedAccountText;
